export enum RouteHistoryMode {
  Registered,
  All
}



// WEBPACK FOOTER //
// ./src/app/pillar/layout/route-history-mode.ts